import React, { useState } from "react"
import pageMessageBroker from './page_message_broker';

export default function FlashMessages({messages}) {
  const [messageList, setMessageList] = useState(messages || []);

  return (
    <div className="absolute fixed top-10 right-0 z-50 h-0 w-full flex flex-col items-center justify-start gap-4 p-8 pointer-events-none">
      {messageList.map(([type, message], index) => (
        <div key={index} className="bg-white rounded-lg border border-gray-100 shadow-lg text-gray-500 w-sm pl-8 pr-16 py-6 rounded relative pointer-events-auto" role="alert">
          <span className="block sm:inline">{message}</span>
          <button onClick={() => setMessageList(messageList.filter((_, i) => i !== index))} className="absolute top-6 right-8 w-6 h-6 cursor-pointer text-gray-500 hover:text-gray-700 focus:outline-none focus:shadow-outline" aria-label="Close">
            <svg className="fill-current h-6 w-6" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
          </button>
        </div>
      ))}
    </div>
  )
}
